import { Table, Row, Col, Container } from "react-bootstrap";
import { API_URL } from "../App";
import { UserDataContext } from "../components/UserDataContext";
import { useState, useEffect, useContext } from "react";
import axios from "axios";
import Card from "react-bootstrap/Card";
import { marginTop } from "../App";
import { ArcherContainer, ArcherElement } from "react-archer";
import { TaskContext } from "../components/TaskContext";
import { apiRequest } from "../components/Config";

export default function TaskStory() {
  const { userData } = useContext(UserDataContext);
  const [data, setData] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const { taskId } = useContext(TaskContext);

  const toggleRow = (index) => {
    setExpandedRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  useEffect(() => {
    if (userData) {
      const fetchData = async () => {
        try {
          const response = await apiRequest(`taskstory/${taskId}`, "GET");
          if (Array.isArray(response)) {
            setData(response);
          } else if (response && Array.isArray(response.data)) {
            setData(response.data);
          } else {
            console.warn("Nieprawidłowa struktura odpowiedzi z API:", response);
            setData([]);
          }
        } catch (error) {
          console.error(error.message);
        }
      };
      fetchData();
    }
  }, [userData]);

  if (taskId === 0) {
    return (
      <Container>
        <h4>Zlecenie ID1: {taskId}</h4>
        <p>
          Prawdopodobnie odświeżona została zawartość strony. Przejdź ponownie
          do Zleceń i wybierz ponownie...
        </p>
      </Container>
    );
  }

  return (
    <ArcherContainer
      strokeColor="blue"
      strokeWidth={2}
      arrowLength={10}
      arrowThickness={6}
    >
      <Container>
        {data &&
          data.map((item, index) => (
            <div
              key={index}
              className="d-flex align-items-center justify-content-center"
            >
              <Row style={{ marginTop }}>
                <ArcherElement
                  id={`card-${index}`}
                  relations={
                    index >= 0
                      ? [
                          {
                            targetId: `card-${index + 1}`,
                            targetAnchor: "top",
                            sourceAnchor: "bottom",
                            style: { strokeColor: "black", strokeWidth: 2 },
                            style: {
                              strokeDasharray: "12,5",
                              strokeColor: "black",
                              strokeWidth: 1,
                            },
                          },
                        ]
                      : []
                  }
                >
                  <Card style={{ width: "48rem" }}>
                    <Card.Body>
                      <Row>
                        <Col>
                          <div className={item.class}></div>
                          <p className="p3">
                            Status: {item.status} {item.performer}
                          </p>
                        </Col>

                        <Col>
                          <p className="p3">Utworzył: {item.createdBy}</p>
                        </Col>
                        <Col>
                          <p className="p3">{item.created}</p>
                        </Col>
                      </Row>
                      <p className="p3"></p>

                      <Card.Text
                        onClick={() => toggleRow(index)}
                        style={{ color: "blue", cursor: "pointer" }}
                      >
                        {expandedRows[index] ? (
                          item.content
                        ) : (
                          <>
                            {item.content ? item.content.slice(0, 50) : ""}
                            {item.content &&
                              item.content.length > 50 &&
                              "[...]"}
                          </>
                        )}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </ArcherElement>
              </Row>
            </div>
          ))}
        <hr />
      </Container>
    </ArcherContainer>
  );
}
